// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".carousel-img[data-v-0c823424]{margin:0 auto;max-height:350px;max-width:523px}.carousel-title_font[data-v-0c823424]{font-size:2.125rem!important;font-weight:700;line-height:2.5rem}.carousel-sub-title[data-v-0c823424]{font-size:24px;font-style:normal;font-weight:400;line-height:34px;margin:0 auto;max-width:600px}.catamaran[data-v-0c823424]{font-family:\"Catamaran\",sans-serif!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
